module.exports = {
	go : function(rou){
		window.location.href = '#!/' + rou;
	},
	/**
     * 姓名的验证
     */
    isName: function(str) {
        var patrn = /^\s*[\u4e00-\u9fa5]{1,15}\s*$/; //中文匹配正则
        var result = str.match(patrn);
        if (result == null) return false;
        return true;
    },
    /**
     * 手机号码的验证
     */
    isPhone: function(str) {
        var reg = /^1\d{10}$/;
        var result = str.match(reg);
        if (result == null) return false;
        return true;
    },
    /**
     * 固定电话
     */
    isMTel: function(str) {
        var reg = /^(^0\d{2}-?\d{8}$)|(^0\d{3}-?\d{7}$)|(^\(0\d{2}\)-?\d{8}$)|(^\(0\d{3}\)-?\d{7}$)$/;
        var result = str.match(reg);
        if (result == null) return false;
        return true;
    },
    /**
     * 固定电话与座机验证
     */
    isTel: function (str) {
        var reg = /^(^(0[0-9]{2,3}\-?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$)|(^((\(\d{3}\))|(\d{3}\-))?(1[358]\d{9})$)/;
        var result = str.match(reg);
        if (result == null) return false;
        return true;
    },
    /**
     * 匹配中文、英文和数字
     */
    isNormalstr: function(str) {
        var reg = /^[\u4e00-\u9fa5a-z0-9]+$/gi;//只能输入汉字和英文字母
        if (reg.test(str)) {
            return true;
        } else {
            return false;
        }
    },
    /**
     * 是否含有特殊字符
     */
    isSpecialstr: function(str) {
        var reg = /^[\u4e00-\u9fa5a-z]+$/gi;//只能输入汉字和英文字母
        if (reg.test(str)) {
            return true;
        } else {
            return false;
        }
    },
    /**
     * 过滤特殊字符
     */
    stripscript: function(s) {
        var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）&mdash;—|{}【】‘；：”“'。，、？]")
        var rs = "";
        for (var i = 0; i < s.length; i++) {
            rs = rs + s.substr(i, 1).replace(pattern, '');
        }
        return rs;
    },
    /*
     * 非空验证
     */
    isNull: function(str) {
        str += "";
        if(str.replace(/(^s*)|(s*$)/g, "").length ==0) {
            return false;
        }
        return true;
    },
    /**
     * 非空数组验证
     */
    isNoArr: function(str) {
        if(str.length < 1) {
            return false;
        } 
        return true;
    },
    /*
    * 标识是否大于0
    */
    isGtZero : function(number){
        number = parseInt(number);
        return number > 0;
    },
    /**
	 * 正整数的验证
	 * @param  {[type]}  str [description]
	 * @return {Boolean}     [description]
	 */
	isPositiveInt: function(str) {
        str += '';
		var reg = /^[0-9]*[1-9][0-9]*$/;
		var result = str.match(reg);
		if(result == null){return false;}
		return true;
	},
     /**
     * 非负整数
     */
    isNonnegativeInt: function(str) {
        str += '';
        var reg = /^(0|[1-9]\d*)$/;
        var result = str.match(reg);
        if(result == null){return false;}
        return true;         
    },
	/**
	 * 数字+字母(工商营业执照) 13/15/18位
	 */
	isBusLicense: function(str) {
		var reg = /^[A-Za-z0-9]{13}$|^[A-Za-z0-9]{15}$|^[A-Za-z0-9]{18}$/;
		var result = str.match(reg);
		if(!result){return false;}
		return true;
	},
	/**
	 * 密码验证
	 */
	isPassword: function(str) {
		var reg = /^\S{6,16}$/
		var result = str.match(reg);
		if(!result){return false;}
		return true;
	},    
    /**
    * 字数是否超过指定的长度
    * @param len 字数的最大长度
    */
    isMaxLen : function(str,len){
        str += "";
        return (str.length > len);
    },
    /**
    * 字数是否不足指定的长度
    * @param len 字数的最小长度
    */
    isMinLen : function(str,len){
        str += "";
        return (str.length < len)
    },
    /**
     * 字数限制
     */
    isOver60: function(str) {
        if(str.length > 60) {
            return false;
        }
        return true;
    },
    isOver30: function (str) {
         if(str.length > 30) {
            return false;
        }
        return true;
    },
    /**
    * 移除字符两边空格
    */
    trim :function(str){
　　    return str.replace(/(^\s*)|(\s*$)/g, "");
　　 },
    /**
    * 移除字符左边空格
    */
　　 ltrim : function(){
　　    return this.replace(/(^\s*)/g,"");
　　 },
    /**
    * 移除字符右边空格
    */
　　 rtrim : function(){
　　    return this.replace(/(\s*$)/g,"");
　　 },
    
    /**
     * 提示框
     * @param  {[type]} txt  文本内容
     * @param  {[type]} time 持续秒数
     * @param  {[type]} type success||error
     * @parma callback 回调函数
     * @return {[type]}      [description]
     */
    tipDialog: function(txt,time,type,callback) {
        var self = this;
        self.rmTipDialog();//之前有提示框，先移除
        var tips = document.getElementById('dialog');
        if(tips) {
            return false;
        }
        tips = document.createElement('div');
        tips.id = 'dialog';
        if(type == 'error') {
            tips.innerHTML = '<div class="tipDialog"><span><i class="glyphicon glyphicon-remove-circle i-red"></i>'+txt+'</span></div>';
        } else if(type == 'success') {
            tips.innerHTML = '<div class="tipDialog"><span><i class="glyphicon glyphicon-ok-circle i-green"></i>'+txt+'</span></div>';
        }else if(type == 'loading'){
            tips.innerHTML = '<div class="tipDialog"><span><i class="glyphicon glyphicon-repeat eleCircle i-green"></i>'+txt+'</span></div>';
        }
        
        document.body.appendChild(tips);
        if(time > 0){
            setTimeout(function() {
                self.rmTipDialog();
                if(callback){
                    callback();
                }
            },time);
        }
    },
     /**
    * 移除
    */
    rmTipDialog : function(){
        var dialog = document.getElementById("dialog");
        if(dialog != null && dialog != undefined){
            document.body.removeChild(dialog);
        }
    },
    /**
     * 表单验证
     * @param  {[type]} ver 验证数据 是一个数组
     * @param  {[type]} data 表示数据对象
     * @return {[type]}     [description]
     */
    validate: function(ver,data) {
        var bool = true;
        for(var i in ver) {
            if(!ver[i][1](data[ver[i][0]])) {
                this.tipDialog(ver[i][2],1500,'error');
                bool = false;
                break;
            } 
        }
        return bool;
    },
    /**
     * 提示确认弹出框
     * @txt  提示信息
     * @callback  回调函数
     */
    confirm: function(txt, callback) {
        // alert('tips....' + txt);
        //
        var tipDialog = ([
            '<div class="tip-Dialog">',
            '<div class="tip-header">',
            '<h4 class="tip-title">提示信息</h4>',
            '<button class="close J_close">&times;</button>',
            '</div>',
            '<div class="tip-body">'+txt+'</div>',
            '<div class="tip-footer">',

            '<button type="button" class="btn btn-primary c_cancel">取消</button>',
            '<button type="button" class="btn btn-primary c_confirm">确定</button>',
            '</div>',
            '</div>',
        ]).join('');
        $('body').append(tipDialog);
        var blackBlock = ['<div class="blackBlock"></div>'].join('');
        var wHeight = $(window).height();
        var wWidth = $(window).width();
        $('.blackBlock').css({'height': wHeight,'width':wWidth});
        $('body').append(blackBlock);
        $('.c_cancel,.J_close').click(function(event) {
            $('.tip-Dialog,.blackBlock').remove();
        });
        $('.c_confirm').click(function(event) {
            callback();
            $('.tip-Dialog,.blackBlock').remove();
        });
    },
    /**
     * 将origin有的属性值全部设置到obj上
     */
    propertyToObj: function(obj, origin) {
        for (var v in origin) {
            obj[v] = origin[v];
        }
    },
    /**
     * 将origin的属性设置到obj上
     * obj 与 origin 有相同的属性才设置
     */
    setProperty: function(obj, origin) {
        for (var v in origin) {
            if (obj.hasOwnProperty(v) && origin[v]) {
                obj[v] = origin[v];
            }
        };
    },
    /**
     *  将origin的属性设置到obj上
     *  obj 与 origin 有相同的属性才设置 为空也行
     */
    updateProperty: function(obj, origin) {
        for (var v in origin) {
            if (obj.hasOwnProperty(v)) {
                obj[v] = origin[v];
            }
        };
    },
    /**    
    * 排序数据
    * @param data 排序的数据
    * @param start 拖拽对象索引
    * @param end 目标对象索引
    */
   sortArr : function(data,start,end){
        var drag = data[start];
        var arr = [];//新的排序后的数组
        for(var i = 0,len = data.length; i < len; i++){
            if(arr.length == end){
                arr.push(drag);
            }
            if(i != start){
                arr.push(data[i]);
            }
            if(arr.length == end){
                arr.push(drag);
            }
        }
        return arr;
    },
    /**
    * 判断各个组件，是否验证通过
    * @param vm 用于判断的组件对象
    */
    isAdopt : function(vm){
        var comp = vm.$children;//组件列表
        var isOK = true;//记录输入框组件，是否全部通过
        for(var i = 0,len = comp.length; i < len; i++){
            if(comp[i].isAdopt){
                if(!comp[i].isAdopt()){
                    isOK = false;
                }
            }
        }
        return isOK;
    },
    /**
     * 存储登录状态cookie
     * @parma k 存储的K
     * @param v 存储的值
     * @param t 存储的时间
     */
    setCookie: function(t) {
        t = t || 12000;
        var val = new Date().getTime() + t;//时间存储的值
        var exp = new Date(val);//cookie10秒钟过期时间
        // console.log("val:" + val  + ",间隔:"  + t + ",过期:" + exp);
        // 设置cookie
        document.cookie = "lg=" + val + "; expires=" + exp.toGMTString();
        // console.log("更新cookie:%O",document.cookie);
    }, 
    /**
    * 获取cookie中的值
    */
    getCookie : function(){
        var cookieName = "lg=",
            cookieStart = document.cookie.indexOf(cookieName),
            cookieValue = null;
        if(cookieStart > -1){
            var cookieEnd = document.cookie.indexOf(";",cookieStart);
            if(cookieEnd == -1){
                cookieEnd = document.cookie.length;
            }
            cookieValue = decodeURIComponent(document.cookie.substring(cookieStart + cookieName.length,cookieEnd));
        }
        return cookieValue;
    },
    /**
    * 获得系统当前时间
    */
    getCurTime: function(){
        var curTime = new Date();
        var year = curTime.getFullYear();
        var month = curTime.getMonth()+1;
        var day = curTime.getDate();
        if(month <=9) month = '0'+month;
        return year + '-' + month + '-' + day;
    }
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/Common.js
 ** module id = 23
 ** module chunks = 0
 **/